<h1 mat-dialog-title>Error</h1>
<div mat-dialog-content>
    <p mat-body-1>{{ data.message }}</p>
</div>
<div mat-dialog-actions >
    <button mat-button [mat-dialog-close]>Okay!</button>
</div>
